import { render } from "./portal-roles.vue?vue&type=template&id=46f0519c"
import script from "./portal-roles.vue?vue&type=script&lang=js"
export * from "./portal-roles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__